import { Dialog, DialogContent } from "@mui/material"
import { CadastrarEditarCupom } from "../CadastrarEditarCupom";
import { ICupom } from "../../../../../pedidos/interface/ICupom";
import { FieldValues } from "react-hook-form";

interface CadastrarEditarCupomModalProps {
    handleCancelar: () => void;
    handleCadastrarCupom: (cupom: FieldValues) => void;
    handleEditarCupom: (cupom: FieldValues) => void;
    open: boolean;
    loading: boolean;
    dadosCupom?: ICupom
}

export const CadastrarEditarCupomModal = ({ open, handleCancelar, handleEditarCupom, handleCadastrarCupom, dadosCupom, loading }: CadastrarEditarCupomModalProps) => {
    return (
        <Dialog 
            open={open} 
            onClose={handleCancelar} 
            maxWidth="sm" 
            fullWidth={false}
            PaperProps={{
                sx: {
                    width: '500px',
                    maxHeight: '80vh'
                }
            }}
        >
            <DialogContent sx={{ 
                overflowY: 'auto',
                padding: '1.5rem'
            }}>
                <CadastrarEditarCupom
                    cadastrar={handleCadastrarCupom}
                    editar={handleEditarCupom}
                    cancelar={handleCancelar}
                    loading={loading}
                    dadosCupom={dadosCupom}
                />
            </DialogContent>
        </Dialog>
    )
}

